import { FC } from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Logo } from 'TaxAnalyticsImages';
import { useHistory } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';

const useStyles = makeStyles((theme) => ({
    noPadding: {
        padding: '0'
    },
    render: {
        imageRendering:'crisp-edges'
    }
}));
export const DeloitteLogoButton: FC = (props) => {
    const classes = useStyles();
    const history = useHistory();
    return <Button onClick={() => {
        history.push("/"); scroll.scrollToTop()}} id="test" className={classes.noPadding}>
        <img src={Logo} alt="Deloitte|Taj" height={48} className={classes.render}/>
    </Button>
}